module.exports = __webpack_public_path__ + "static_pc/img/pay.32f8131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/pay.png
// module id = Pl2m
// module chunks = 1